export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              关于我们
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              每日大赛黑料 —— 全网最认真的吃瓜平台
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="flex flex-col lg:flex-row gap-8 items-center">
              <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20dramatic%20warm%20lighting%2C%20journalism%20and%20media%20aesthetic%2C%20dark%20elegant%20office%20with%20multiple%20screens%2C%20professional%20yet%20mysterious%20atmosphere%2C%20editorial%20photography%20style%20with%20deep%20shadows%20and%20golden%20accents&width=480&height=480&seq=about-2026&orientation=squarish"
                  alt="每日大赛黑料 - 关于我们"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
              </div>
              <div className="flex-1">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  每日大赛黑料创立于2024年，是国内领先的大赛吃瓜与黑料吃瓜群信息聚合平台。我们聚焦选秀、综艺、电竞、网红等各类竞技赛事，以第一手大赛内幕、每日黑料最新资讯和深度调查报道，为数百万吃瓜群众提供最及时、最劲爆的大赛八卦内容。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  我们的团队由资深娱乐记者、数据调查员和社区运营专家组成，坚持"真实爆料、深度挖掘、理性吃瓜"的运营理念。每日大赛黑料的每一条信息都经过交叉验证，黑料围观不仅仅是看热闹，更是对赛事公平的关注与监督。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  目前，每日大赛黑料已覆盖全网主要的社交媒体和内容平台，黑料吃瓜群成员突破十万，每日吃瓜爆料更新频率行业领先。未来我们将继续深耕大赛黑料领域，以更优质的内容和服务回馈每一位吃瓜群众的支持。
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-3">
                  <span className="px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">真实爆料</span>
                  <span className="px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">深度挖掘</span>
                  <span className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">理性吃瓜</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}